














































































import FeedbackComponent from '@/components/base/FeedbackComponent'
import ConcentrationOfInquiriesModal
  from "@/components/dashboard/concentration-of-inquiries/modal/ConcentrationOfInquiriesModal.vue";
import CreateNewCustomerServiceCRMContact
  from "@/components/dashboard/customer-service/components/CreateNewCustomerServiceCRMContact.vue";
import MemberCRMContactCallHistory
  from "@/components/dashboard/find-member-or-employer/tabs/MemberCRMContactCallHistory.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {CrmFilterType} from "@/models/CrmFilterType";
import {EmployerCRMDetails, MemberCRMDetails} from "@/store/modules/customerService";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {Action} from "vuex-class";

@Component({
  components: {
    CreateNewCustomerServiceCRMContact,
    MemberCRMContactCallHistory,
    ConcentrationOfInquiriesModal
  }
})
export default class CRMContactHistoryGrid extends FeedbackComponent {

  @Prop(String) entityId!: string;
  @Prop(Boolean) isMember!: boolean;
  @Action('fetchCRMContacts', StoreNamespace.CUSTOMER_SERVICE) fetchCRMContacts: any
  @Action('getMemberDetails', StoreNamespace.CUSTOMER_SERVICE) getMemberDetails: any;
  @Action('getEmployerDetails', StoreNamespace.CUSTOMER_SERVICE) getEmployerDetails: any;

  private showAddNewContactForCustomerService: boolean = false
  private columns: GridColumn[] = [];
  private memberAccounts: any[] | undefined = []
  private memberCRMDetails: MemberCRMDetails | null = null;
  private employerCRMDetails: EmployerCRMDetails | null = null;
  private showPopup: boolean = false;
  private uniqueIdentifier: any = null;
  private member: any = null;
  private crmId: number = -1;
  private crmFilterType: CrmFilterType | null = null

  private showContactCallHistoryPopup: boolean = false;
  private selectedContact: any = {}


  mounted() {
    if (this.isMember) {
      this.crmFilterType = CrmFilterType.MEMBER;
    } else {
      this.crmFilterType = CrmFilterType.EMPLOYER;
    }

    this.initColumns();
    this.getGridData({});
  }

  initColumns(): void {
    this.columns.push({property: 'crmId', header: 'MemberContactHistoryGrid.contactNumber'} as GridColumn)
    this.columns.push({property: 'dateCreated', header: 'MemberContactHistoryGrid.contactDate'} as GridColumn)
    this.columns.push({property: 'createdUser', header: 'MemberContactHistoryGrid.createdUser'} as GridColumn)
    this.columns.push({property: 'arrivalSubject', header: 'MemberContactHistoryGrid.contactSubject'} as GridColumn)
    this.columns.push({property: 'contactSource', header: 'MemberContactHistoryGrid.contactSource'} as GridColumn)
    this.columns.push({
      property: 'statusCRM',
      header: 'MemberContactHistoryGrid.contactStatus',
      hideSorting: true
    } as GridColumn)
    this.columns.push({
      property: 'userContactRouting',
      header: 'MemberContactHistoryGrid.contactRoutingUser'
    } as GridColumn)
    this.columns.push({property: 'privateNotes', header: 'MemberContactHistoryGrid.notes'} as GridColumn)
  }


  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {
      case 'CRMContacts':
        this.$emit('successResults', data)
        break;
      case 'getMemberDetails':
        this.memberCRMDetails = data;
        this.memberAccounts = []
        if (this.memberCRMDetails) {
          this.memberAccounts = this.memberCRMDetails.accountsList
        }
        this.showAddNewContactForCustomerService = true
        break;
      case 'getEmployerDetails':
        this.employerCRMDetails = data
        this.showAddNewContactForCustomerService = true

    }
  }

  private getGridData(searchObject: any) {
    searchObject.pageSize = -1;
    searchObject.uniqueIdentifier = this.entityId;

    if (!this.isMember) {
      searchObject.isEmployer = true
    }

    this.fetchCRMContacts({
      requestorCallback: this,
      requestBody: searchObject,
    });
  }

  private onAddNewContactClicked() {
    if (this.isMember) {
      this.crmFilterType = CrmFilterType.MEMBER
      this.getMemberDetails({
        pathVariable: this.entityId,
        requestorCallback: this
      });
    } else {
      this.crmFilterType = CrmFilterType.EMPLOYER
      this.getEmployerDetails({
        pathVariable: this.entityId,
        requestorCallback: this
      });
    }
  }

  private onCloseAddNewContact() {
    this.showAddNewContactForCustomerService = false
    this.memberCRMDetails = null
    this.employerCRMDetails = null
    this.crmFilterType = null;
  }

  private onCloseSuccessAddingNewContact() {
    this.showAddNewContactForCustomerService = false
    this.memberCRMDetails = null
    this.employerCRMDetails = null
    this.getGridData({});
  }

  private onClosePopup() {
    this.showPopup = false;
    this.crmId = -1
    this.member = null;
    this.uniqueIdentifier = null
  }

  private onRowClick(row: any) {
    this.crmId = row.crmId
    this.showPopup = true;
    this.member = row.member;
    this.entityId = row.uniqueIdentifier
  }

  private onShowContactCallHistory(clickedRow: any) {
    this.crmId = clickedRow.crmId
    this.selectedContact = clickedRow
    this.showContactCallHistoryPopup = !this.showContactCallHistoryPopup;
  }
}


